import axiosInstance from ".";

export const userLogin = (data) => {
  return axiosInstance.post("/users/login", data);
};
